/*
 * immutably removes element from 'array' at 'index'
 *
 * arrayRemoveIndex([ 'foo', 'bar', 'baz' ], 1) -> [ 'foo', 'baz' ]
 */

module.exports = function arrayRemoveIndex (array, index) {
  return [
    ...array.slice(0, index),
    ...array.slice(index + 1)
  ]
}
